'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

const navLinks = [
  { href: '/#features', label: 'Features' },
  { href: '/#pricing', label: 'Pricing' },
  { href: '/why-direct-debit', label: 'Why Direct Debit' },
  { href: '/#about', label: 'About' },
];

export function SiteHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-warm-gray-200">
      <div className="max-w-[1400px] mx-auto px-6 flex items-center justify-between h-[72px]">
        <Link href="/" className="flex items-center gap-3 no-underline group">
          <Image src="/logo.svg" alt="" width={44} height={44} className="group-hover:scale-105 transition-transform" />
          <span className="font-display text-2xl font-medium text-navy tracking-tight">TrusteeKit</span>
        </Link>
        <nav className="hidden md:flex gap-1">
          {navLinks.map((link) => (
            <Link key={link.href} href={link.href} className="text-warm-gray-600 no-underline font-medium text-sm px-4 py-2 rounded-lg transition-colors hover:text-trust-blue hover:bg-warm-gray-100">{link.label}</Link>
          ))}
          <Link href="/login" className="text-warm-gray-600 no-underline font-medium text-sm px-4 py-2 rounded-lg transition-colors hover:text-trust-blue hover:bg-warm-gray-100">Sign in</Link>
          <Link href="/signup" className="ml-2 text-white no-underline font-semibold text-sm px-5 py-2.5 rounded-lg bg-navy hover:bg-navy-light transition-colors">Get started</Link>
        </nav>
        <button
          className="md:hidden flex flex-col justify-center gap-[5px] w-8 h-8 bg-transparent border-none cursor-pointer p-1 z-110"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-navy rounded-xs transition-all ${mobileMenuOpen ? 'rotate-45 translate-y-[7px]' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-navy rounded-xs transition-all ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-navy rounded-xs transition-all ${mobileMenuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`}></span>
        </button>
      </div>
      {/* Mobile menu */}
      <nav className={`${mobileMenuOpen ? 'flex' : 'hidden'} md:hidden fixed top-[72px] left-0 right-0 bg-white border-b border-warm-gray-200 p-4 flex-col gap-2 z-99 shadow-lg`}>
        {navLinks.map((link) => (
          <Link key={link.href} href={link.href} className="block text-warm-gray-600 no-underline font-medium text-base px-4 py-3 rounded-lg hover:text-trust-blue hover:bg-warm-gray-100" onClick={() => setMobileMenuOpen(false)}>{link.label}</Link>
        ))}
        <Link href="/login" className="block text-warm-gray-600 no-underline font-medium text-base px-4 py-3 rounded-lg hover:text-trust-blue hover:bg-warm-gray-100 text-center" onClick={() => setMobileMenuOpen(false)}>Sign in</Link>
        <Link href="/signup" className="block text-white no-underline font-semibold text-base px-4 py-3 rounded-lg bg-navy text-center mt-2" onClick={() => setMobileMenuOpen(false)}>Get started</Link>
      </nav>
    </header>
  );
}
